import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { Business } from '../models/business.model';
import { hasTag, loadTags } from '../../util/tag-utils';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
/** Degree tag display names that need an apostrophe to match the University Finder filter labels. */
var DEGREE_DISPLAY_NAME_OVERRIDES = {
    'Bachelors': 'Bachelor\'s',
    'Masters': 'Master\'s'
};
function formatDegreeTag(tagDisplayName) {
    return DEGREE_DISPLAY_NAME_OVERRIDES[tagDisplayName.toString()] || tagDisplayName;
}
var EducationalInfoComponent = /** @class */ (function () {
    function EducationalInfoComponent(_toggleService, _editEducationalInfoCheckboxDialog, _businessManagerService, _tagService, snackBar) {
        var _this = this;
        this._toggleService = _toggleService;
        this._editEducationalInfoCheckboxDialog = _editEducationalInfoCheckboxDialog;
        this._businessManagerService = _businessManagerService;
        this._tagService = _tagService;
        this.snackBar = snackBar;
        this.affiliatesTags = [];
        this.degreesTags = [];
        this.majorsTags = [];
        this.hasTag = hasTag;
        this.editModeSet = false;
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    EducationalInfoComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allTags, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllTags();
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allTags = _c.sent();
                        this.setApprovedForVA(allTags);
                        this.setDistanceLearning(allTags);
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 2:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 3:
                        _b = !(_c.sent());
                        _c.label = 4;
                    case 4:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EducationalInfoComponent.prototype, "hasContent", {
        get: function () {
            return this.business &&
                (this.affiliatesTags.length > 0 || this.degreesTags.length > 0 ||
                    this.majorsTags.length > 0 || this.hasDistanceLearning || this.isCollegeApprovedForVaTraining);
        },
        enumerable: true,
        configurable: true
    });
    EducationalInfoComponent.prototype.openEditEducationalInfoDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editEducationalInfoCheckboxDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this.loadAllTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    EducationalInfoComponent.prototype.loadAllTags = function () {
        this.affiliatesTags = loadTags(this.business.tags, 'College::Accreditation::', '', '');
        this.degreesTags = loadTags(this.business.tags, 'College::Degrees::', '', '').map(formatDegreeTag);
        this.majorsTags = loadTags(this.business.tags, 'College::Majors::', '', '');
    };
    EducationalInfoComponent.prototype.setApprovedForVA = function (allTags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'College::Approved for VA')];
                    case 1:
                        _a.vaApprovedTag = _b.sent();
                        this.isCollegeApprovedForVaTraining = hasTag(this.business.tags, 'College::Approved for VA');
                        return [2 /*return*/];
                }
            });
        });
    };
    EducationalInfoComponent.prototype.setDistanceLearning = function (allTags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'College::Distance Learning')];
                    case 1:
                        _a.distanceLearningTag = _b.sent();
                        this.hasDistanceLearning = hasTag(this.business.tags, 'College::Distance Learning');
                        return [2 /*return*/];
                }
            });
        });
    };
    EducationalInfoComponent.prototype.isCollegeApprovedForVaTrainingChange = function (radioChange) {
        if (radioChange.source.value === '1' && !this.isCollegeApprovedForVaTraining) {
            this.isCollegeApprovedForVaTraining = true;
            this.updateRadioBtnTagStatus(this.vaApprovedTag, false);
        }
        else if (radioChange.source.value === '2' && this.isCollegeApprovedForVaTraining) {
            this.isCollegeApprovedForVaTraining = false;
            this.updateRadioBtnTagStatus(this.vaApprovedTag, true);
        }
    };
    EducationalInfoComponent.prototype.hasDistanceLearningChange = function (radioChange) {
        if (radioChange.source.value === '1' && !this.hasDistanceLearning) {
            this.hasDistanceLearning = true;
            this.updateRadioBtnTagStatus(this.distanceLearningTag, false);
        }
        else if (radioChange.source.value === '2' && this.hasDistanceLearning) {
            this.hasDistanceLearning = false;
            this.updateRadioBtnTagStatus(this.distanceLearningTag, true);
        }
    };
    EducationalInfoComponent.prototype.updateRadioBtnTagStatus = function (tag, shouldDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, tagId, newBusiness, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        tagId = tag.tagId;
                        if (!shouldDelete) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.deleteTag(tagId, this.business.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.postTag(tagId, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 6:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return EducationalInfoComponent;
}());
export { EducationalInfoComponent };
